import request from '@/utils/request';
// 获取活动预告
export function getNextActivityList(params) {
    return request({
        url: '/netbar/api/activity_forecast/v1/getPageList',
        method: 'post',
        params
    })
}
//往期活动
export function getHistoryActivityList(params) {
    return request({
        url: '/netbar/api/activity/v1/getEndActivityList',
        method: 'get',
        params
    })
}
// 获取抽奖活动
export function drawrule(params) {
    return request({
        url: '/netbar/api/activity/v1/getActivity',
        method: 'get',
        params
    })
}
// 活动抽奖
export function activitygift(params) {
    return request({
        url: '/netbar/api/activity/v1/gift',
        method: 'get',
        params
    })
}
// 获取中奖列表
export function getActivityWinnerList(params) {
    return request({
        url: '/netbar/api/activity/v1/getActivityWinnerList',
        method: 'get',
        params
    })
}
// 我的奖品
export function getUserActivityWinner(params) {
    return request({
        url: '/netbar/api/activity/v1/getUserActivityWinner',
        method: 'get',
        params
    })
}
// 剩余抽奖次数
export function getUserGiftCount(params) {
    return request({
        url: '/netbar/api/activity/v1/getUserGiftCount',
        method: 'get',
        params
    })
}
// 我的积分
export function getUserIntegral(params) {
    return request({
        url: '/netbar/api/integral/v1/getUserIntegral',
        method: 'get',
        params
    })
}
// 获取信息
export function getNetbarId(params) {
    return request({
        url: '/netbar/api/netbar/v1/select_by_netbar_id',
        method: 'get',
        params
    })
}
// 提交信息
export function submitWinner(data) {
    return request({
        url: '/netbar/api/activity/v1/submitWinner',
        method: 'post',
        data
    })
}
// 获取省
export function getProvince(data) {
    return request({
        url: '/netbar/api/common/v1/getProvince',
        method: 'post',
        data
    })
}
// 获取市
export function getCity(data) {
    return request({
        url: '/netbar/api/common/v1/getCity',
        method: 'post',
        data
    })
}
// 获取区
export function getArea(data) {
    return request({
        url: '/netbar/api/common/v1/getArea',
        method: 'post',
        data
    })
}
